import prodHandler from './prod';
export var handlers = {
    prod: prodHandler
};
